<template>
  <div>
  <my-request-layout
    :workflowGuid="registration.workflowGuid"
    :foundRequest="!!registration"
    :isLoading="isLoading"
    :myRequest="registration"
    :cancelRequest="cancelRequest"
    :paymentStatus="paymentStatus"

    useAuthorizedPayment
    :makePayment="makePayment"
    :showPaymentAuthorizationStatus="registration.needsPaymentAuthorization"
  >
    <span slot="title"
      >Change Kennel Owners: {{ registration.kennelName }}</span
    >

    <div slot="requestContent" v-if="registration && registration.newOwners" class="mb-5">
      <change-kennel-owners :registration="registration"></change-kennel-owners>
    </div>
  </my-request-layout>
  <v-snackbar v-model="showErrorMessage" title color="error">
    {{ errorMessage }}
    <template v-slot:action="{ attrs }">
    <v-btn color="primary" text v-bind="attrs" @click="showErrorMessage = false">
      Close
    </v-btn>
    </template>
  </v-snackbar>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import AuthorizeNetResponseData from "@/types/AuthorizeNetResponseData";
import MyRequestLayout from "@/components/Portal/MyRequest/MyRequestLayout.vue";
import ChangeKennelOwners from "@/components/Portal/MyRequest/ChangeKennelOwners.vue";
import { UserInfo } from "@/types/User";
import workflowService from "@/services/portal/workflowService";

export default Vue.extend({
  name: "MyChangeKennelOwnerRequest",
  components: {
    MyRequestLayout,
    ChangeKennelOwners,
  },
  data: function () {
    return {
      registration: Object as any,
      isLoading: false,
      paymentStatus: null,
      errorMessage: "",
      showErrorMessage: false,
    };
  },
  props: {
    workflowGuid: { type: String },
  },
  methods: {
    load() {
      this.isLoading = true;
      workflowService
        .getChangeKennelOwnerRequestDetails(this.workflowGuid)
        .then((res) => {
          this.isLoading = false;
          this.registration = res;
        });
    },
    makePayment: function (paymentInfo: AuthorizeNetResponseData) {
      var req = {
        paymentInfo,
        workflowGuid: this.registration.workflowGuid,
      };

      workflowService.submitKennelOwnerCCPayment(req).then((res) => {
        if (res.error) {
          this.errorMessage = res.error;
          this.showErrorMessage = true;
        }
        else {
          this.paymentStatus = res;
        }

        this.load();
      });
    },
    cancelRequest: function () {
    },
  },
  created() {
    this.load();
  },
  watch: {
    workflowGuid: function (newValue) {
      this.load();
    },
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
  },
});
</script>
